import avatar01 from "@/assets/avatars/01.png";
import avatar03 from "@/assets/avatars/03.png";
import avatar04 from "@/assets/avatars/04.png";
import avatar08 from "@/assets/avatars/08.png";

export const FRAME_PER_SECOND = 5;

interface Pod {
  pod: string;
  enabled: boolean;
  avatar?: string;
}

export const pods: Pod[] = [
  { pod: "01", enabled: true, avatar: avatar01 },
  { pod: "02", enabled: false },
  { pod: "03", enabled: true, avatar: avatar03 },
  { pod: "04", enabled: true, avatar: avatar04 },
  { pod: "05", enabled: false },
  { pod: "06", enabled: false },
  { pod: "07", enabled: false },
  { pod: "08", enabled: true, avatar: avatar08 },
  { pod: "09", enabled: false },
];
